import type {
  ItemCategoryRecord,
  ItemCategoryType,
} from "@project/types/item-category";

import { JIVANDHARA_BASE, fetchListPage } from "../admin/list-api-helpers";
import type { ListQuery, PaginatedResult } from "@project/types/location";

const BASE = `${JIVANDHARA_BASE}/item-categories`;

class PublicItemCategoryService {
  listActiveByType = (
    item_category_type: ItemCategoryType,
    query: ListQuery = {}
  ): Promise<PaginatedResult<ItemCategoryRecord>> =>
    fetchListPage<ItemCategoryRecord>(`${BASE}/`, {
      page_size: 100,
      ...query,
      item_category_type,
      status: "active",
    });
}

export const publicItemCategoryService = new PublicItemCategoryService();
